import { h, render } from 'preact';
import fetchData from './api';
import Content from './components/Content';

function getSelectedInputs(inputsParent) {
  const allInputs = document.querySelector(inputsParent);
  const checkedNodeList = allInputs.querySelectorAll('input:checked'); // aqui
  const checkedItems = Array.from(checkedNodeList);

  const result = checkedItems.map((item) => item.id);

  return result;
}

function showLoading(isVisible) {
  const loading = document.querySelector('.programming2020Container__main__body__loading');

  if (isVisible === false) {
    loading.classList.remove('programming2020Container__main__body__loading--active')
    return;
  }

  loading.classList.add('programming2020Container__main__body__loading--active')
}

async function showFilteredContent() {
  showLoading(true);

  const selectedStages = getSelectedInputs('#sidemenu_stages_list');
  const selectedTags = getSelectedInputs('#sidemenu_tags_list');
  const selectedDay = getSelectedInputs('#programming2020Container__main__top__days');
  const searchText = document.querySelector('.programming2020Container__sidemenu__search__input').value;
  const contentBody = document.getElementById('programming2020Container__main__body');

  const dataFetched = await fetchData(selectedDay, selectedStages, selectedTags, searchText);
  const data = Object.entries(dataFetched);

  contentBody.innerHTML = '';
  showLoading(false);

  document.querySelector('#timezone').options[0].selected = true;

  if (data[0][0] === 'code') {
    render(<span style={{ display: 'grid', margin: '0 auto', width: 'fit-content' }}>{dataFetched.message}</span>, contentBody);
  }

  render(<Content data={data} />, contentBody);
}

function addClickListeners() {
  const eventDays = document.querySelector('.programming2020Container__main__top').querySelectorAll('input');
  const filterButton = document.querySelector('.programming2020Container__sidemenu__btn');
  const searchBtn = document.querySelector('.programming2020Container__sidemenu__search__btn');
  const searchInput = document.querySelector('.programming2020Container__sidemenu__search__input');

  if (eventDays) {
    eventDays.forEach((day) => day.addEventListener('click', () => showFilteredContent()));
  }

  if (filterButton) {
    filterButton.addEventListener('click', () => showFilteredContent());
  }

  if (searchBtn) {
    searchBtn.addEventListener('click', () => showFilteredContent());
  }

  if (searchInput) {
    searchInput.addEventListener('keyup', (event) => {
      if (event.keyCode === 13) {
        showFilteredContent();
      }
    });
  }
}

window.addEventListener('load', addClickListeners);
